import { sendEvent } from "./sendEvent";
import type { GtmItem } from "./types";

type EcommercePayload = {
	currency?: string;
	value?: number;
	items: GtmItem[];
	[key: string]: unknown;
};

/**
 * Push a GA4 ecommerce event. The `{ ecommerce: null }` reset first is the
 * standard GTM guard so `items` from a previous event don't bleed into this one.
 */
const sendEcommerce = (event: string, ecommerce: EcommercePayload) => {
	sendEvent({ ecommerce: null });
	sendEvent({ event, ecommerce });
};

type ItemListPayload = { currency?: string; value?: number; items: GtmItem[] };

export const trackViewItem = (payload: ItemListPayload) => sendEcommerce("view_item", payload);

export const trackAddToCart = (payload: ItemListPayload) => sendEcommerce("add_to_cart", payload);

export const trackBeginCheckout = (payload: ItemListPayload) =>
	sendEcommerce("begin_checkout", payload);

export const trackPurchase = (payload: {
	transaction_id: string;
	currency?: string;
	value?: number;
	tax?: number;
	shipping?: number;
	items: GtmItem[];
}) => sendEcommerce("purchase", payload);

/** Non-ecommerce event — only the form name, no PII. */
export const trackGenerateLead = (payload: { form_name: string }) =>
	sendEvent({ event: "generate_lead", form_name: payload.form_name });
